import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Grid,
  Button,
  Modal,
} from '../../../components/index';
import {
  validateObject,
  // doGet,
} from '../../../utils/requests';
import { getObject, sexo, estadoCivil, vinculo, capacidade, motivoInclusao } from '../../../utils/listsSelect';
import Masks from '../../../utils/masks';

class DependenteCessacao extends Component {
  static getDerivedStateFromProps(props, state) {
    const { validadeCampos } = { ...state };
    let touched = false;
    if (props.dependente && !state.didProps) {
      if (props.errosDependente) {
        props.errosDependente.forEach((item) => {
          validadeCampos[item.atributo] = false;
        });
        return ({
          dependente: { ...props.dependente },
          validadeCampos,
          errosDependente: props.errosDependente,
          touched: true,
          didProps: true,
        });
      }
      // Object.keys(validadeCampos).forEach((key) => {
      if (props.dependente.dataCessacao !== undefined && props.dependente.motivoCessacao !== null) {
        validadeCampos.motivoCessacao = true;
        touched = true;
      }
      if (props.dependente.dataCessacao !== undefined && props.dependente.dataCessacao !== '') {
        validadeCampos.dataCessacao = true;
        touched = true;
      }
      // }
      // });
      return ({ dependente: { ...props.dependente }, touched, didProps: true });
    }
    return null;
  }

  constructor() {
    super();
    const state = this.getInitialState();
    this.state = state;
  }

  getInitialState = () => {
    const initialState = {
      dependente: {
        cpfDependente: null,
        nome: null,
        nomeMae: null,
        dataNascimento: null,
        sexo: null,
        estadoCivil: null,
        vinculo: null,
        capacidade: null,
        motivoInclusao: null,
        invalidezDeAcordoMedico: null,
        dataCessacao: null,
        motivoCessacao: null,
        cessando: null,
        foiCessado: null,
        ordemCessacao: null,
      },
      touched: false,
      validadeCampos: {
        dataCessacao: false,
        motivoCessacao: false,
      },
      didUpdate: false,
      didProps: false,
      estadoFormulario: 'inicial',
    };
    return initialState;
  }

  formularioProntoParaEnvio = () => {
    const { estadoFormulario } = { ...this.state };
    if (estadoFormulario === 'cessacao-dependente') {
      return validateObject(this.state.validadeCampos);
    }
    return false;
  }

  handleCancelar = () => {
    if (this.state.dependente.dataCessacao === '' ||
      this.state.dependente.motivoCessacao === '') {
      this.state.dependente.cessando = false;
    }
    this.props.cancelarCessacaoDependente(this.state.dependente);
    this.resetState();
  }

  resetState = () => {
    this.setState(this.getInitialState());
    this.props.onHide();
    this.props.resetDependente();
  }

  handleButton = () => {
    const touched = true;
    this.setState({ ...this.state, touched }, this.handleEnviar);
  }

  handleEnviar = () => {
    const { estadoFormulario } = { ...this.state };
    if (estadoFormulario === 'cessacao-dependente' &&
    this.state.dependente.dataCessacao &&
    this.state.dependente.motivoCessacao) {
      this.state.dependente.cessando = true;
      this.state.didUpdate = true;
    }
    this.props.cessarDependente(this.state.dependente);
    this.resetState();
  }

  handleChange = (changeObj, name) => {
    let { estadoFormulario } = { ...this.state };
    estadoFormulario = 'cessacao-dependente';
    this.setState({
      dependente: {
        ...this.state.dependente,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
      estadoFormulario,
    });
  }

  addVinculoLabel = (vinculoSelecionado) => {
    const obj = getObject(vinculo, vinculoSelecionado);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
  }

  addSexoLabel = (sexoSelecionado) => {
    const obj = getObject(sexo, sexoSelecionado);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
  }

  addEstadoCivilLabel = (estadoCivilSelecionado) => {
    const obj = getObject(estadoCivil, estadoCivilSelecionado);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
  }

  addCapacidadeLabel = (capacidadeSelecionada) => {
    const obj = getObject(capacidade, capacidadeSelecionada);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
  }

  addMotivoInclusaoLabel = (motivoInclusaoSelecionado) => {
    const obj = getObject(motivoInclusao, motivoInclusaoSelecionado);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
  }

  addMotivoCessacaoLabel = (motivoCessacaoSelecionado) => {
    const obj = getObject(this.props.motivosCessacaoDependente, motivoCessacaoSelecionado);
    let valorlabel = null;
    if (obj) {
      valorlabel = obj.label;
    }
    return valorlabel;
  }

  render() {
    const modalContent = (
      <React.Fragment>
        <div className="row" style={{ height: '400px', 'overflow-y': 'auto', 'overflow-x': 'hidden' }}>
          <div className="row">
            <Grid cols="6 6 6 6">
              <Input
                disabled
                cpf
                label="CPF"
                mask={Masks.cpf}
                showMask
                value={this.state.dependente.cpfDependente}
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="12 12 12 12">
              <Input
                disabled
                label="Nome"
                maxLength="60"
                value={this.state.dependente.nome}
              />
              <Input
                disabled
                label="Nome da Mãe"
                maxLength="60"
                value={this.state.dependente.nomeMae}
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Data de Nascimento"
                mask={Masks.date}
                value={this.state.dependente.dataNascimento}
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Sexo"
                value={this.addSexoLabel(this.state.dependente.sexo)}
                number
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Estado Civil"
                value={this.addEstadoCivilLabel(this.state.dependente.estadoCivil)}
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Vínculo"
                value={this.addVinculoLabel(this.state.dependente.vinculo)}
                number
                custom
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Capacidade"
                value={this.addCapacidadeLabel(this.state.dependente.capacidade)}
                number
                custom
              />
            </Grid>
            <Grid cols="4 4 4 4">
              <Input
                disabled
                label="Motivo de Inclusão"
                value={this.addMotivoInclusaoLabel(this.state.dependente.motivoInclusao)}
                number
              />
            </Grid>
          </div>
          <div className="row">
            <Grid cols="6 6 6 6">
              {this.state.dependente.foiCessado ?
                <Input
                  disabled
                  label="Motivo da Cessação"
                  value={this.addMotivoCessacaoLabel(this.state.dependente.motivoCessacao)}
                  custom
                />
              :
                <Input
                  disabled={this.state.dependente.foiCessado}
                  label="Motivo da Cessação"
                  error={!this.state.validadeCampos.motivoCessacao}
                  touched={this.state.touched}
                  placeholder="Selecione o motivo da cessação"
                  onChange={e => this.handleChange(e, 'motivoCessacao')}
                  value={this.state.dependente.motivoCessacao}
                  itemList={this.props.motivosCessacaoDependente}
                  number
                  required
                  custom
                />
              }
            </Grid>
            <Grid cols="6 6 6 6">
              <Input
                disabled={this.state.dependente.foiCessado}
                mask={Masks.date}
                error={!this.state.validadeCampos.dataCessacao}
                label="Data da Cessação"
                onChange={e => this.handleChange(e, 'dataCessacao')}
                value={this.state.dependente.dataCessacao}
                touched={this.state.touched}
                required
              />
            </Grid>
          </div>
        </div>
      </React.Fragment>
    );
    const modalFooter = (
      <React.Fragment>
        <div className="right">
          <Button
            title="Fechar"
            onClick={this.handleCancelar}
            hint="Fechar"
          />
          <Button
            className="dtp-primary"
            disabled={!this.formularioProntoParaEnvio()}
            title="Salvar"
            onClick={this.handleButton}
            hint="Cessar dependente"
          />
        </div>
      </React.Fragment>
    );

    return (
      <Modal
        {...this.props}
        conteudomodal={modalContent}
        conteudofooter={modalFooter}
        onHide={this.handleCancelar}
        showTitle
        size="lg"
        title="Cessação de Dependente"
      />
    );
  }
}

DependenteCessacao.propTypes = {
  acaoModal: PropTypes.string,
  onHide: PropTypes.func,
  consulta: PropTypes.bool,
  motivosCessacaoDependente: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
}.isRequired;

export default DependenteCessacao;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Cessacao/DependenteCessacao.jsx